
const _ = require('lodash');

module.exports = _.extend({
	prompt: require('./js/prompt-api'),
}, require('./js/modals-api'));
